/**
 * Safely copy text to the clipboard.
 * navigator.clipboard is only available in secure contexts (HTTPS or localhost).
 * Over HTTP (e.g. network URL like http://192.168.x.x:3000) it is undefined.
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  if (typeof navigator === 'undefined') return false

  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text)
      return true
    } catch {
      // fall through to fallback
    }
  }

  // Fallback for non-secure contexts (e.g. HTTP on network URL)
  try {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.select()
    const ok = document.execCommand('copy')
    document.body.removeChild(textarea)
    return ok
  } catch {
    return false
  }
}
